/**
 * Size Guide Drawer - Slide-in panel functionality
 */

class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this;
    this.overlay = this.querySelector('.size-guide-drawer__overlay');
    this.panel = this.querySelector('.size-guide-drawer__panel');
    this.closeButton = this.querySelector('.size-guide-drawer__close');

    this.bindEvents();
  }

  bindEvents() {
    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    // Close on close button click
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    // Close on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Listen for open events from SIZE GUIDE links
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-size-guide-trigger]');
      if (trigger) {
        event.preventDefault();
        this.open();
      }
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    document.body.classList.add('size-guide-open');

    // Focus the close button for accessibility
    if (this.closeButton) {
      setTimeout(() => {
        this.closeButton.focus();
      }, 300);
    }

    // Trap focus within drawer
    this.trapFocus();
  }

  close() {
    this.drawer.classList.remove('is-open');
    document.body.classList.remove('size-guide-open');

    // Return focus to the trigger element
    const trigger = document.querySelector('[data-size-guide-trigger]');
    if (trigger) {
      trigger.focus();
    }

    this.removeTrapFocus();
  }

  isOpen() {
    return this.drawer.classList.contains('is-open');
  }

  trapFocus() {
    const focusableElements = this.panel.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    this.handleFocusTrap = (event) => {
      if (event.key !== 'Tab') return;

      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    };

    this.panel.addEventListener('keydown', this.handleFocusTrap);
  }

  removeTrapFocus() {
    if (this.handleFocusTrap) {
      this.panel.removeEventListener('keydown', this.handleFocusTrap);
    }
  }
}

// Register the custom element
if (!customElements.get('size-guide-drawer')) {
  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
